import React from "react";

import AppLink from "../../AppLink";
import DesktopSearchInput from "./DesktopSearchInput";
import NavAccountInfo from "./NavAccountInfo";

import PaperlessPostIcon from "../../Icons/PaperlessPost";

const Masthead = () => {
  return (
    <div className="h-16 flex items-center justify-between w-full px-6">
      <div className="flex justify-start w-1/3">
        <DesktopSearchInput />
      </div>
      <div className="flex justify-center w-1/3">
        <AppLink
          href="/"
          tracking={{
            id: "header-home",
            block_name: "masthead",
            block_row: "masthead",
          }}
        >
          <PaperlessPostIcon className="w-32 h-9" />
        </AppLink>
      </div>
      <div className="flex justify-end w-1/3">
        <NavAccountInfo />
      </div>
    </div>
  );
};

export default Masthead;
